// hooks/useToolpadRouter.js
import { useNavigate, useLocation } from 'react-router-dom';

export function useToolpadRouter() {
  const navigate = useNavigate();
  const location = useLocation();

  return {
    pathname: location.pathname,
    navigate: (path) => navigate(path),
  };
}
